/**
 * Staff API — Modul-Aggregator. Bundelt alle Staff-Resource-Module zu
 * einem `StaffApi` Objekt das in Pages via `useStaffApi()` Hook
 * benutzt wird.
 */

import type { AxiosInstance } from 'axios'
import { createTokensApi, type TokensApi } from './tokens'
import { createServicesApi, type ServicesApi } from './services'
import { createSubscriptionPlansApi, type SubscriptionPlansApi } from './subscriptionPlans'
import { createCortexTenantsApi, type CortexTenantsApi } from './cortexTenants'
import { createVMAssignmentApi, type VMAssignmentApi } from './vmAssignment'
import { createSyncApi, type SyncApi } from './sync'

export interface StaffApi {
  tokens: TokensApi
  services: ServicesApi
  subscriptionPlans: SubscriptionPlansApi
  cortexTenants: CortexTenantsApi
  vmAssignment: VMAssignmentApi
  sync: SyncApi
}

export function createStaffApi(api: AxiosInstance): StaffApi {
  return {
    tokens: createTokensApi(api),
    services: createServicesApi(api),
    subscriptionPlans: createSubscriptionPlansApi(api),
    cortexTenants: createCortexTenantsApi(api),
    vmAssignment: createVMAssignmentApi(api),
    sync: createSyncApi(api),
  }
}

export type { TokensApi, ServicesApi, SubscriptionPlansApi, CortexTenantsApi, VMAssignmentApi, SyncApi }
